import styled, { css } from 'styled-components';
import { applyStylesToMobileExperience } from 'src/molecules/Shared/2024_Q1_people_magic/BaseAnimatedExperienceController/BaseAnimatedExperienceController.styles';

export const OpportunityCalculatorStaticContainer = styled.div`
  max-width: 100vw !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 6rem;
  box-sizing: border-box;
  padding: 6rem 1.5rem;
  width: 100%;

  ${applyStylesToMobileExperience(css`
    padding: 3rem 1.5rem;
    row-gap: 3.5rem;
  `)};
`;
